export default class DealerFilter {
    checkboxes;
    constructor(element, overviewReference, mapRefrence) {
        this.checkboxes = element.querySelectorAll('.js-dealer-checkbox');
        let filterElements = document.querySelectorAll('.js-dealer-filter');
        filterElements.forEach((filter, i) => {
            if (i > 0) {
                filter.remove(); // Remove all filterboxes but the first one
            }
        });
        setTimeout(() => {
            this.checkboxFunction(element, overviewReference, mapRefrence);
        }, 150); // Timeout needed beceause otherwise the checkboxes are empty
        this.checkboxes.forEach((checkbox) => {
            checkbox.addEventListener('click', () => {
                this.checkboxFunction(element, overviewReference, mapRefrence);
            });
        });
    }
    checkboxFunction(element, overviewRefrence, mapRefrence) {
        let checkedboxes = element.querySelectorAll('.js-dealer-checkbox:checked');
        let values = [];
        let overviewContainer = document.querySelector('.js-establishment');
        let mapContainer = document.querySelector('.js-locationmap');
        checkedboxes.forEach((checked) => {
            values.push(checked.value);
        });
        overviewContainer ? overviewRefrence.filterByService(values) : '';
        mapContainer ? mapRefrence.setLocationMarkers(values) : '';
    }
}
